import { useLocalStorage } from "@mantine/hooks"
import { Editor, IAllProps } from "@tinymce/tinymce-react"
import Axios from "axios"
import LocalStorage from "constants/local-storage"
import { useHost } from "global/host.global"
import React from "react"

export type RichTextEditorProps = IAllProps & {}
const RichTextEditor = ({ ...props }: RichTextEditorProps) => {
  const { protocol, host, subdomain } = useHost()
  const [token] = useLocalStorage({ key: LocalStorage.TOKEN })
  const imageUploadLink = `${protocol}://${host}/services/uploader/`
  return (
    <Editor
      apiKey={process.env.REACT_APP_TINY_EDITOR_API_KEY}
      init={{
        skin: "snow",
        async images_upload_handler(blobInfo, progress) {
          return new Promise((resolve, reject) => {
            const formData = new FormData()
            formData.append("file", blobInfo.blob())
            formData.append("path", `${process.env.REACT_APP_ENV}/${subdomain}`)
            Axios.post(imageUploadLink, formData, {
              headers: {
                Tenant: subdomain,
                Authorization: `Bearer ${token}`,
              },
              onUploadProgress(e) {
                progress((e.loaded / e.total) * 100)
              },
            })
              .then(({ data }) => {
                if (data?.url) {
                  resolve(data?.url)
                } else {
                  reject("Unable to upload image")
                }
              })
              .catch(error => {
                reject("Unable to upload file")
              })
          })
        },
        ...props.init,
      }}
      {...props}
    />
  )
}

export default RichTextEditor
